import React from 'react'
import classNames from "classnames/bind"

import styles from "./cookie-policy.module.scss"

const cx = classNames.bind(styles)

export const CookiesPolicy = () => {
    return (
        <div className={cx(['container', 'cookie-policy-wrapper'])}>
            <h1>Cookie Policy</h1>
            <p>Following is a list of cookies in use on the website.</p>

            <h2>Google Analytics</h2>

            <p>The cookies here are used to understand how users interact
                with the website. This data is then compiled in an anonymous format,
                which is used to help improve the flow of the website.

                <br /><br />
                For additional information on the Google Analytics privacy policy, please
                visit <a href="https://support.google.com/analytics/answer/6004245" target="_blank" rel="noopener noreferrer">https://support.google.com/analytics/answer/6004245</a>

                <br /><br />
                You can opt-out of Google Analytics by this link: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout</a>
            </p>

            <h3>Codes being used to track:</h3>
            <ul>
                <li>_utma</li>
                <li>_utmb</li>
                <li>_utmc</li>
                <li>_utmz</li>
            </ul>


        </div>
    )
}